import { getErrorMessage } from "../../../core/data/redux/utils/errorUtils";

export const errMsg = (e: any, fallback: string): string =>
  typeof e === "string" ? e : getErrorMessage(e) || fallback;
